import useHTTP from '@/hooks/useHTTP.mjs'

export default () => {
    const http = useHTTP()
    const params = new URLSearchParams(location.search.split("?")[1]);
    const prjPatternId = params.get('prjPatternId')

    if(prjPatternId) {
        return {
            fetchUeMapJson: (args) => http.get(`/pattern/umuis/ue/${args.pkid}`, {prjPatternId}),
            fetchAlgMapJson: (args) => http.get(`/pattern/umuis/alg/${args.pkid}`, {prjPatternId}),
            fetchProject: (args) => http.get(`/prjs/${args.prjId}/info`),
            // exportImage: (params) => http.post('/convert-uv/image', params)
            fetchUmues: (args) => http.get(`/pattern/umuis/ue/preview`, {...args, prjPatternId}),
            fetchUiById: ({pkid}) => http.get(`/pattern/umuis/${pkid}`, {prjPatternId}),
            fetchUmUv: ({pkid}) => http.get(`/pattern/oneUmUv`, {pkid, prjPatternId}),
            fetchUcListOpr: (args) => http.get(`/rmucs/listOpr`,  {...args}),
            loadTreeMenu: (args) => http.get(`/pattern/archuas/loadUvtree`,  {...args, prjPatternId}),
            changeFile: (args) => http.post(`/files`, args),
        }
    }else {
        return {
            fetchUeMapJson: (args) => http.get(`/umuis/ue/${args.pkid}`),
            fetchAlgMapJson: (args) => http.get(`/umuis/alg/${args.pkid}`),
            fetchProject: (args) => http.get(`/prjs/${args.prjId}/info`),
            // exportImage: (params) => http.post('/convert-uv/image', params)
            fetchUmues: (args) => http.get(`/umuis/ue/preview`, args),
            fetchUiById: ({pkid}) => http.get(`/umuis/${pkid}`),
            fetchUmUv: ({pkid}) => http.get(`/oneUmUv`, {pkid}),
            fetchUcListOpr: (args) => http.get(`/rmucs/listOpr`, args),
            loadTreeMenu: (args) => http.get(`/archuas/loadUvtree`, args),
            genUvForBoard: (args, header) => http.post(`/umuis/genUvForBoard`, args, header),
            changeFile: (args) => http.post(`/files`, args),
        }
    }

    // return {
    //     fetchUeMapJson: (args) => http.get(`/umuis/ue/${args.pkid}`),
    //     fetchAlgMapJson: (args) => http.get(`/umuis/alg/${args.pkid}`),
    //     fetchProject: (args) => http.get(`/prjs/${args.prjId}/info`),
    //     // exportImage: (params) => http.post('/convert-uv/image', params)
    //     fetchUmues: (args) => http.get(`/umuis/ue/preview`, args),
    //     fetchUvByUe: (args) => http.get(`/umuis/getUvByUe`, args),
    //     fetchUiById: ({pkid}) => http.get(`/umuis/${pkid}`),
    //     fetchUmUv: ({pkid}) => http.get(`/oneUmUv`, {pkid}),
    //     fetchUcListOpr: (args) => http.get(`/rmucs/listOpr`, args),
    //     loadTreeMenu: (args) => http.get(`/archuas/loadUvtree`, args),
    // }
}
